<template>
  <div class="gg-sigin mt-3">
    <div id="button_google"></div>
    <div id="error" class="error-message text-center">{{ $t(error.message) }}</div>
  </div>
</template>

<script>
import { store } from '../../store';
import { API_URL, GOOGLE_CLIENT_ID } from "@/constant";

export default {
  name: 'login_signup_social',
  data() {
    return {
      error: {
        message: '',
      },
    }
  },
  mounted() {
    google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: this.callbackSignIn,
    });

    google.accounts.id.renderButton(
      document.getElementById('button_google'),
      {
        type: 'standard',
        shape: 'pill',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        logo_alignment: 'center',
        width: '300px'
      }, // customization attributes
    );
  },
  methods: {
    async callbackSignIn(e) {
      var params = {
        token: e.credential,
        type: 'web'
      };
      store.commit('setLoading', true);
      const response = await $.post(API_URL + '/user/google-sign', params)
      store.commit('setLoading', false);

      if (response.code != 0) {
        if (response.code === 1) {
          window.location.href = '/register?token=' + params.token;
          return
        }

        this.error.message = response.msg
        return
      }

      store.commit('setAuth', true);
      const data = response.results
      const access_token = data.access_token
      const expires_in = data.expires_in
      document.cookie = `_wid=${access_token}; expires=${expires_in},  path=/`;

      localStorage.setItem('access_token', access_token);
      location.href = '/';
    }
  }
}
</script>